<template>
    <div>
        <div class="animated fadeIn row">
            <div class="col-sm-6 col-lg-3" v-for="item in data.root" :key="item.moduleId">
                <b-card no-body class="modules" v-if="item.moduleVersion === 6">
                    <div class="line" v-bind:style="'background-color: '+getColor(item)+';'"></div>
                    <b-card-body class="pb-1 pt-1 pr-1">
                        <div class="float-left temperature">{{item.temperature}} &#8451;</div>
                    </b-card-body>
                    <b-card-body class="pb-1 pt-1">
                        <div class="row">
                            <div class="module-icon col-2" v-on:click="item.values.deviceOn = (item.values.deviceOn === 'true') ? false: true; setThermostat(item)">
                                <div v-html="getThermostatIconData(item)"></div>
                            </div>
                            <div class="col-10">
                                <h2>{{item.moduleName}}</h2>
                            </div>
                        </div>
                        <div class="row" v-if="item.values.deviceOn === 'true' ||item.values.deviceOn === true">
                            <div class="col-4" v-on:mouseup="setThermostat(item)">
                                <round-slider
                                    v-model="item.values.targetTemperature"
                                    start-angle="0"
                                    end-angle="+180"
                                    line-cap="round"
                                    min="10"
                                    max="30"
                                    radius="90"/>
                            </div>
                            <div class="col-8 mt-4">
                                <div class="row ml-4">
                                    <div class="col-8 d-flex">
                                        <div class="mr-2" v-on:click="item.values.systemMode = 'heat'; setThermostat(item)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
                                                <g fill="none" fill-rule="evenodd">
                                                    <path d="M-2 47h48V-1H-2z"/>
                                                    <path :fill="(item.values.systemMode == 'heat') ? item.iconColor : '#CCCCCC'" d="M5.1 36.08l3.58-3.6 2.82 2.82-3.58 3.6-2.82-2.82zM20 43.9V38h4v5.9h-4zM22 10c6.62 0 12 5.38 12 12s-5.38 12-12 12c-6.618 0-12-5.38-12-12s5.382-12 12-12zm16 14v-4h6v4h-6zm-5.52 11.32l2.8-2.8 3.602 3.58-2.822 2.82-3.58-3.6zm6.42-27.4l-3.58 3.58-2.82-2.82 3.58-3.58 2.82 2.82zM20 6V.1h4V6h-4zM0 24v-4h6v4H0zM11.52 8.68L8.68 11.5 5.1 7.92 7.92 5.1l3.6 3.58z"/>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="mr-2" v-on:click="item.values.systemMode = 'cool'; setThermostat(item)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                                <g fill="none" fill-rule="evenodd">
                                                    <path d="M-4 44h48V-4H-4z"/>
                                                    <path :fill="(item.values.systemMode == 'cool') ? item.iconColor : '#CCCCCC'" d="M40 18h-8.34l6.48-6.48-2.82-2.84L26 18h-4v-4l9.32-9.32-2.84-2.82L22 8.34V0h-4v8.34l-6.48-6.48-2.84 2.82L18 14v4h-4L4.68 8.68l-2.82 2.84L8.34 18H0v4h8.34l-6.48 6.48 2.82 2.84L14 22h4v4l-9.32 9.32 2.84 2.82L18 31.66V40h4v-8.34l6.48 6.48 2.84-2.82L22 26v-4h4l9.32 9.32 2.82-2.84L31.66 22H40z"/>
                                                </g>
                                            </svg>
                                        </div>
                                        <div class="mr-2" v-on:click="item.values.systemMode = 'fan_only'; setThermostat(item)">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="37" viewBox="0 0 40 37">
                                                <g fill="none" fill-rule="evenodd">
                                                    <path d="M-4 43h48V-5H-4z"/>
                                                    <path :fill="(item.values.systemMode == 'fan_only') ? item.iconColor : '#CCCCCC'" d="M20 15.23c-1.994 0-3.752.96-4.89 2.424-2.02-4.75-3.454-10.77-3.454-12.254 0-2.534 3.736-4.588 8.344-4.588 4.61 0 8.344 2.054 8.344 4.588 0 1.484-1.432 7.506-3.454 12.256-1.138-1.466-2.896-2.426-4.89-2.426zm-6.215 6.215c0 3.05 2.212 5.582 5.116 6.104-3.116 4.054-7.464 8.144-8.726 8.87-2.208 1.276-5.88-.948-8.198-4.968-2.318-4.02-2.404-8.31-.194-9.586 1.314-.758 7.462-2.584 12.678-3.18a6.137 6.137 0 0 0-.676 2.76zm24.43.473c2.208 1.282 2.108 5.574-.22 9.586-2.33 4.012-6.008 6.226-8.216 4.946-1.26-.732-5.596-4.836-8.698-8.9 2.912-.512 5.134-3.048 5.134-6.104 0-.99-.254-1.914-.668-2.746 5.214.614 11.358 2.456 12.668 3.218zm-14-.473A4.218 4.218 0 0 1 20 25.66a4.219 4.219 0 0 1-4.216-4.214A4.219 4.219 0 0 1 20 17.231a4.218 4.218 0 0 1 4.214 4.214z"/>
                                                </g>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <label>{{$t('FANMODE')}}</label>
                                        <select v-on:change="setThermostat(item)" v-model="item.values.fanMode">
                                            <option value="auto">{{$t('AUTO')}}</option>
                                            <option value="low">{{$t('LOW')}}</option>
                                            <option value="medium">{{$t('MEDIUM')}}</option>
                                            <option value="high">{{$t('HIGH')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card-body>
                </b-card>
                <b-card no-body class="modules" v-else-if="item.moduleVersion === 16">
                    <div class="line" v-bind:style="'background-color: '+getColor(item)+';'"></div>
                    <b-card-body class="pb-1 pt-1 pr-1">
                        <div class="float-left temperature">{{item.temperature}} &#8451;</div>
                        <div v-if="item.offline" class="mr-2 mt-1 text-right">
                            <i class="icon-exclamation" style="color: red;"></i>
                        </div>
                    </b-card-body>
                    <b-card-body class="pb-1 pt-1">
                        <div class="row">
                            <div class="module-icon col-2" v-on:click.prevent="item.power = !item.currentValue; setDimmer(item)">
                                <div v-html="getIconData(item)"></div>
                            </div>
                            <div class="col-10">
                                <h2>{{item.moduleName}}</h2>
                            </div>
                        </div>
                        <div class="row" v-if="item.currentValue === 1">
                            <div class="col-4" v-on:mouseup="setDimmer(item)">
                                <round-slider
                                    v-model="item.values.brightness"
                                    start-angle="0"
                                    end-angle="+180"
                                    line-cap="round"
                                    min="0"
                                    max="100"
                                    radius="90"/>
                            </div>
                        </div>
                    </b-card-body>
                    <div v-if="item.tempShown">
                        <div class="m-3 text-right" v-on:click="setGlobalGraphData(item, 'temperature')">
                            <i class="icon-crop"></i>
                        </div>
                        <modulegraph :tempData="item.logData" :label="$t('TEMPERATURE')" field="temperature" class="chart-wrapper px-3" style="height:80px;" height="80" />
                    </div>
                </b-card>
                <b-card no-body class="modules" v-else-if="item.moduleVersion === 17">
                    <div class="line" v-bind:style="'background-color: '+getColor(item)+';'"></div>
                    <b-card-body class="pb-1 pt-1 pr-1">
                        <div class="float-left temperature">{{item.temperature}} &#8451;</div>
                        <div v-if="item.offline" class="mr-2 mt-1 text-right">
                            <i class="icon-exclamation" style="color: red;"></i>
                        </div>
                    </b-card-body>
                    <b-card-body class="pb-1 pt-1">
                        <div class="row">
                            <div class="module-icon col-2" v-on:click.prevent="item.power = !item.currentValue; setDimmer(item)">
                                <div v-html="getIconData(item)"></div>
                            </div>
                            <div class="col-10">
                                <h2>{{item.moduleName}}</h2>
                            </div>
                        </div>
                        <div class="row" v-if="item.currentValue === 1">
                            <div class="col-4" v-on:mouseup="setDimmer(item)">
                                <round-slider
                                    v-model="item.values.brightness"
                                    start-angle="0"
                                    end-angle="+180"
                                    line-cap="round"
                                    min="0"
                                    max="100"
                                    radius="90"/>
                            </div>
                        </div>
                        <div class="row" v-if="item.currentValue === 1">
                            <div class="col-4" v-on:mouseup="setDimmer(item)">
                                <colorpicker v-model="item.values.ledcolor"></colorpicker>
                            </div>
                        </div>
                    </b-card-body>
                    <div v-if="item.tempShown">
                        <div class="m-3 text-right" v-on:click="setGlobalGraphData(item, 'temperature')">
                            <i class="icon-crop"></i>
                        </div>
                        <modulegraph :tempData="item.logData" :label="$t('TEMPERATURE')" field="temperature" class="chart-wrapper px-3" style="height:80px;" height="80" />
                    </div>
                </b-card>
                <b-card no-body class="modules" v-else>
                    <div class="line" v-bind:style="'background-color: '+getColor(item)+';'"></div>
                    <b-card-body class="pb-1 pt-1 pr-1">
                        <div class="float-left temperature">{{item.temperature}} &#8451;</div>
                        <div v-if="item.analogDevice != 0 && item.analogDevice != null" class="float-left temperature ml-3">{{item.analogValue}} {{getAnalogMeasure(item)}}</div>
                        <div v-if="item.offline" class="mr-2 mt-1 text-right">
                            <i class="icon-exclamation" style="color: red;"></i>
                        </div>
                        <b-dropdown v-else class="float-right" variant="transparent p-0" right>
                            <template slot="button-content">
                                <i class="icon-settings"></i>
                            </template>
                            <b-dropdown-item v-on:click="item.tempShown = !item.tempShown">{{$t('TOGGLETEMPERATUREVIEW')}}</b-dropdown-item>
                            <b-dropdown-item v-on:click="getTemp(item)">{{$t('REFRESHTEMPERATURE')}}</b-dropdown-item>
                            <b-dropdown-item v-on:click="reset(item)">{{$t('RESTART')}}</b-dropdown-item>
                            <b-dropdown-item v-if="item.analogDevice != 0 && item.analogDevice != null" v-on:click="item.analogShown = !item.analogShown">{{getAnalogLabel(item)}}</b-dropdown-item>
                            <b-dropdown-item v-if="item.irCodesData && item.irCodesData.length > 0" v-on:click="item.irCodesShown = !item.irCodesShown">{{$t('IRCODES')}}</b-dropdown-item>
                        </b-dropdown>
                    </b-card-body>
                    <b-card-body class="pb-1 pt-1">
                        <div class="row">
                            <div class="module-icon col-2" v-on:click.prevent="activateModule(item)">
                                <div v-html="getIconData(item)"></div>
                            </div>
                            <div v-if="item.digitalDevice === 2 || item.digitalDevice === 3 || item.moduleVersion === 10 || item.moduleVersion === 15" class="module-icon col-2" v-on:click.prevent="activateSecModule(item)">
                                <div v-html="getIconData(item, true)"></div>
                            </div>
                            <div v-bind:class="(item.digitalDevice === 2 || item.digitalDevice === 3 || item.moduleVersion === 10 || item.moduleVersion === 15) ? 'col-8' : 'col-10'">
                                <h2>{{item.moduleName}}</h2>
                            </div>
                        </div>
                    </b-card-body>
                    <div v-if="item.tempShown">
                        <div class="m-3 text-right" v-on:click="setGlobalGraphData(item, 'temperature')">
                            <i class="icon-crop"></i>
                        </div>
                        <modulegraph :tempData="item.logData" :label="$t('TEMPERATURE')" field="temperature" class="chart-wrapper px-3" style="height:80px;" height="80" />
                    </div>
                    <div v-if="item.irCodesShown">
                        <ul class="list-group">
                            <li v-for="irCode in item.irCodesData" :key="irCode.irCodeId" class="list-group-item" v-on:click.prevent="sendCode(irCode, item.moduleId)">
                                <h6>{{irCode.deviceName}}</h6>
                                <h4>{{irCode.codeName}}</h4>
                            </li>
                        </ul>
                    </div>
                    <div v-if="item.analogShown">
                        <div class="m-3 text-right" v-on:click="setGlobalGraphData(item, 'analogValue')">
                            <i class="icon-crop"></i>
                        </div>
                        <modulegraph :tempData="item.logData" :label="getAnalogLabel(item)" field="analogValue" class="chart-wrapper px-3" style="height:80px;" height="80" />
                    </div>
                </b-card>
            </div>
        </div>
        <div class="animated fadeIn row">
            <div class="col-sm-12" v-if="globalGraphShown">
                <b-card no-body class="modules">
                    <div class="m-3 text-right" v-on:click="globalGraphShown = false">
                        <i class="icon-close"></i>
                    </div>
                    <modulegraph :tempData="globalGraphData.data" :label="globalGraphData.label" :field="globalGraphData.field" :show-details="true" class="chart-wrapper px-3" style="height:200px;" height="200" />
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters
}
from 'vuex'
import Api from '@/api/Modules'
import IrApi from '@/api/IrCodes'
import ModuleGraph from './ModuleGraph.vue'

import { Chrome } from 'vue-color';

export default
{
    name: 'Dashboard',
    components:
    {
        modulegraph: ModuleGraph,
        colorpicker: Chrome,
    },
    data()
    {
        return {
            data:
            {},
            globalGraphData:
            {},
            globalGraphShown: false,
            temp: false,
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 200,
                searchTimeout: false
            }
        }
    },
    created()
    {
        var me = this;
        me.getData();

        me.socket.on('module', (message) =>
        {
            if (me.data.root)
            {
                for (let module of me.data.root)
                {
                    if (module.moduleId === message.moduleId)
                    {
                        me.$set(me.data.root, me.data.root.indexOf(module), message);
                    }
                }
            }
        });
    },
    methods:
    {
        sendCode(item, moduleId)
        {
            let me = this;
            item.moduleId = moduleId;
            IrApi.sendCode(item, (val) => {
                if (val.error)
                {
                    me.$notify.notice(val);
                    me.formError = val;
                }
                else
                {
                    me.$notify.notice(val);
                    me.formError = {};
                    me.getData();
                }
            });
        },
        setGlobalGraphData(item, field)
        {
            let me = this;

            let label = me.$t('TEMPERATURE');
            if (field == 'analogValue') {label = me.getAnalogLabel(item);}

            me.globalGraphShown = false;
            me.$nextTick(() =>
            {
                me.globalGraphData = {
                
                data: item.logData,
                    field: field,
                    label: label};
                me.globalGraphShown = true;
            });
        },
        activateModule(item)
        {
            let me = this;
            Api.activateModule(item, (data) => {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
            });
        },
        setThermostat(item)
        {
            let me = this;
            Api.setThermostat(item).catch((error) =>
            {
                me.$notify.notice(error);
            });
        },
        setDimmer(item)
        {
            let me = this;
            item.brightness = item.values.brightness;
            if (item.values && item.values.ledcolor && item.values.ledcolor.rgba)
            {
                item.ledcolor = {
                    r: item.values.ledcolor.rgba.r,
                    g: item.values.ledcolor.rgba.g,
                    b: item.values.ledcolor.rgba.b,
                };
            }
            Api.setDimmer(item).catch((error) =>
            {
                me.$notify.notice(error);
            });
        },
        activateSecModule(item)
        {
            let me = this;
            Api.activateSecModule(item, (data) => {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
            });
        },
        getTemp(item)
        {
            let me = this;
            Api.getTemp(item, (data) => {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
            });
        },
        reset(item)
        {
            let me = this;
            Api.reset(item, (data) => {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }
            });
        },
        getColor(item)
        {
            let me = this;
            if (item.currentValue == 1) {return item.iconColor;}
            return '#ccc';
        },
        getSecColor(item)
        {
            let me = this;
            if (item.currentSecValue == 1) {return item.iconColor;}
            return '#ccc';
        },
        getIconData(item, sec = false)
        {
            if (!sec)
            {
                if (item.currentValue == 1) return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="'+item.iconColor+'"');
                return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="#cccccc"');
            }

            if (item.currentSecValue == 1) return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="'+item.iconColor+'"');
            else return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="#cccccc"');
        },
        getThermostatIconData(item)
        {
            if (item.values.deviceOn === 'true' || item.values.deviceOn === true) return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="'+item.iconColor+'"');
            return item.icondata.replace(/fill="#(.*?[^\\])"/gm, 'fill="#cccccc"');
        },
        getAnalogLabel(item)
        {
            let me = this;
            switch (item.analogDevice)
            {
            case 1:
                return me.$t('SOUNDDBLEVEL');
                break;
            case 2:
                return me.$t('PRESSURELEVEL');
                break;
            }
        },
        getAnalogMeasure(item)
        {
            let me = this;
            switch (item.analogDevice)
            {
            case 1:
                return me.$t('DB');
                break;
            case 2:
                return me.$t('BAR');
                break;
            case 3:
                return '%';
                break;
            }
        },
        getData()
        {
            var me = this;
            Api.selectRow(me.getParams, function(data)
            {
                if (data.error && data.error == true)
                {
                    me.$notify.notice(data);
                    return;
                }

                for (var item of data.root)
                {
                    var found = false;
                    if (me.data.root)
                    {
                        for (var oldItem of me.data.root)
                        {
                            if (oldItem.moduleId == item.moduleId)
                            {
                                found = true;
                                item.analogShown = oldItem.analogShown;
                                item.tempShown = oldItem.tempShown;
                                item.irCodesShown = oldItem.irCodesShown;
                                break;
                            }
                        }
                    }

                    if (!found)
                    {
                        item.analogShown = false;
                        item.tempShown = false;
                        item.irCodesShown = false;
                    }
                }

                me.data = data;
            });
        }
    },
    watch:
    {
        'pagination.currentPage'(val)
        {
            var me = this;
            me.getData();
        },
        'pagination.query'(val)
        {
            var me = this;

            if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

            me.pagination.searchTimeout = setTimeout(function()
            {
                me.getData();
                me.pagination.searchTimeout = false;
            }, 300);
        }
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'socket',
        ]),
        getParams()
        {
            var me = this;
            var data = Object.assign(
            {}, me.pagination,
            {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        }
    },
};
</script>
